import Image from "next/image";
import type { HeroProps } from "../types";

const SchoolProfile = ({ image, title }: HeroProps) => {
  return (
    <>
      {/* Hero Banner Section */}
      <div
        className="relative overflow-hidden bg-cover bg-center"
        style={{ backgroundImage: "url(/bg-images/hero-bg.jpg)" }}
      >
        {/* Content Container */}
        <div className="container relative flex flex-col md:flex-row items-center justify-between px-4 pt-[72px] pb-16 md:py-16 gap-6 md:gap-0">
          {/* School Logo - Top on Mobile, Right on Desktop */}
          {image?.sourceUrl && (
            <div className="relative w-[190px] h-[75px] md:w-[268px] md:h-[99px] bg-white rounded-[8px] order-1 md:order-2">
              <Image
                src={image.sourceUrl}
                alt={image.altText || `${title} logo`}
                fill
                className="object-contain"
              />
            </div>
          )}

          {/* School Name - Bottom on Mobile, Left on Desktop */}
          <h1 className="elm-h1 font-black text-white m-0 p-0 text-center md:text-left order-2 md:order-1">
            {title}
          </h1>
        </div>
      </div>
    </>
  );
};

export default SchoolProfile;
